const initialValues = { phone: '', password: '', phoneCountry: 1 };
export default initialValues;
